import { supabase } from "../../../supabaseClient";
import useCustomQuery from "../../shared/hooks/useCustomQuery";
import { Task } from "../models/Task";

export const useTask = (id: number) => {
  return useCustomQuery({
    queryKey: "task",
    queryFn: async () => {
      const { data, error } = await supabase
        .from("tasks")
        .select("*")
        .eq("id", id)
        .single();
      if (error) {
        throw error;
      }

      if (!data) {
        throw new Error("No data returned");
      }

      return data; // return the Task object directly
    },
    options: {},
  });
};
